// extracted by mini-css-extract-plugin
export var button = "_g6-4";
export var hasDarkBackground = "_g6-7";
export var hasLightBackground = "_g6-6";
export var iconWrapper = "_g6-0";
export var large = "_g6-2";
export var medium = "_g6-1";
export var small = "_g6-5";
export var xsmall = "_g6-3";